import get from 'lodash/get'

// Builds ordered listings with ADs salted in
export function buildOrderedListings({
  itineraries,
  hasExpressDeal,
  packagesEvery10thListing,
  isRoundTrip,
  isWhiteLabel = false,
  AIR_LISTINGS_AD_CLICK_OFF,
}) {
  const showCrossSellBannerSeti = packagesEvery10thListing
  const OFFSET = 3
  const SEPARATION = 5
  const orderedListings = []
  const startWithAd = 1

  /**
   * adsLength is based on pclnGptDartAds.length on FE. Need a better approach for adsLength
   * */
  const options = {
    adCount: 0,
    adsLength: 4, //
  }

  let nodesCount = 0
  let exdMoreThanRetail
  let firstExdIter = true

  itineraries.forEach((element, index) => {
    nodesCount++
    if (get(element, 'isExpressDeal', false) && index === 4) {
      exdMoreThanRetail = true
    }

    const {
      minimumNodes,
      everyTenListings,
      initialHigherExd,
      initialLowerExd,
      betweenNinthTenthListing,
      everyTenNodes,
    } = crossSellPosition(
      nodesCount,
      exdMoreThanRetail,
      firstExdIter,
      hasExpressDeal,
      index
    )

    if (index === 2 && !isWhiteLabel) {
      orderedListings.push({
        isSponsoredAd: true,
        adId: AIR_LISTINGS_AD_CLICK_OFF
          ? 'div-gpt-ad-1672930738853-0'
          : 'div-gpt-ad-1621948623733-0',
      })
    }

    if (initialHigherExd || (initialLowerExd && index < 7)) {
      firstExdIter = false
      nodesCount = 0
    }
    if (
      crossSellItinPush(
        minimumNodes,
        everyTenListings,
        initialHigherExd,
        initialLowerExd,
        betweenNinthTenthListing,
        everyTenNodes,
        hasExpressDeal,
        index,
        exdMoreThanRetail,
        firstExdIter,
        showCrossSellBannerSeti
      ) &&
      isRoundTrip
    ) {
      orderedListings.push({
        crossSellAd: true,
      })
    }

    if (index === OFFSET - 1) {
      orderedListings.push(element)
      if (startWithAd && options.adCount < options.adsLength) {
        // first ad placement position matched
        orderedListings.push({
          ad: true,
          adIndex: options.adCount,
        })

        options.adCount++
      }
    } else if (
      index >= OFFSET + SEPARATION - 1 &&
      (index - (OFFSET - 1)) % SEPARATION === 0
    ) {
      if (Math.floor(index / SEPARATION) % 2 !== startWithAd) {
        orderedListings.push(element)

        if (options.adCount < options.adsLength) {
          // ad placement position with respective interval matched after the 1st & 2nd ad
          orderedListings.push({
            ad: true,
            adIndex: options.adCount,
          })

          options.adCount++
        }
      } else {
        orderedListings.push(element)
      }
    } else {
      orderedListings.push(element)
    }
  })

  return { listings: orderedListings }
}

function crossSellPosition(
  nodesCount,
  exdMoreThanRetail,
  firstExdIter,
  hasExpressDeal,
  counter
) {
  const everyTenListings = counter % 10 === 0
  const everyTenNodes = nodesCount % 10 === 0
  const betweenNinthTenthListing =
    counter < 10 ? counter % 9 === 0 : (counter - 1) % 9 === 0
  const everyFifthListing = nodesCount % 6 === 0
  const minimumNodes = nodesCount > 3
  const initialHigherExd =
    hasExpressDeal &&
    minimumNodes &&
    betweenNinthTenthListing &&
    exdMoreThanRetail &&
    firstExdIter
  const initialLowerExd =
    hasExpressDeal &&
    minimumNodes &&
    everyFifthListing &&
    !exdMoreThanRetail &&
    firstExdIter
  return {
    minimumNodes,
    everyTenListings,
    initialHigherExd,
    initialLowerExd,
    betweenNinthTenthListing,
    everyTenNodes,
  }
}

function crossSellItinPush(
  minimumNodes,
  everyTenListings,
  initialHigherExd,
  initialLowerExd,
  betweenNinthTenthListing,
  everyTenNodes,
  hasExpressDeal,
  index,
  exdMoreThanRetail,
  firstExdIter,
  showCrossSellBannerSeti
) {
  if (showCrossSellBannerSeti) {
    if (index === 10 || (index > 0 && index % 10 === 0)) {
      return true
    }
  } else {
    if (hasExpressDeal) {
      if (
        exdMoreThanRetail &&
        betweenNinthTenthListing &&
        index < 10 &&
        !firstExdIter
      ) {
        return true
      }
      if (minimumNodes && index > 11 && everyTenNodes) {
        return true
      }
    }
    if (minimumNodes && everyTenListings && !hasExpressDeal) {
      return true
    }
    if (initialHigherExd || (initialLowerExd && index < 7)) {
      return true
    }
    return false
  }
}
